import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from "antd";

import { actions } from "store";
import { JobForm, JobList } from "components/blocks/Job";
import { SitePageForm } from 'components/blocks/Site';


class JobListScreen extends Component {
  render() {
    const { site, history } = this.props;
    const detail = site.detail;

    return (
      <Fragment>
        <div className="page-content page-content-full">
          <div className="page-block page-block-full">
            {detail &&
            <JobList
              history={history}
              activeFilter={{ site: detail.id }}
              topActions={[
                <Button type="primary" className="" icon="plus" onClick={() => this.showForm()}>
                  Добавить анкету
                </Button>
              ]}
            />}
          </div>
        </div>

        {detail &&
        <JobForm siteId={detail.id}/>}

        {detail &&
        <SitePageForm siteId={detail.id}/>}
      </Fragment>
    );
  }
}


function mapStateToProps(state) {
  return {
    site: state.site,
    job: state.job,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.job), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(JobListScreen);
